'use client'

/**
 * Shown when an iframe errors, the social provider script doesn't render
 * within the timeout window, or URL parsing rejects an embed input.
 * Always reachable: the page never shows a blank slot.
 */
export function EmbedFallbackCard({
  url,
  providerLabel,
  reason,
}: {
  url: string
  providerLabel: string
  reason?: string
}) {
  return (
    <div className="not-prose my-6 mx-auto max-w-md rounded-lg border border-gray-200 bg-gray-50 p-5 text-center">
      <p className="text-xs uppercase tracking-wide text-gray-500">
        {providerLabel}
      </p>
      <p className="mt-2 text-sm text-gray-700">
        {reason ?? "This embed couldn't load."}
      </p>
      {url && (
        <a
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          className="mt-3 inline-block text-sm font-medium text-[var(--color-cta-readable)] hover:underline"
        >
          Open in {providerLabel} →
        </a>
      )}
    </div>
  )
}
